import React from 'react'
import Layout from '../components/layout-global'
import Sponsors from '../components/sponsors'

const page = () => (
  <Layout centered>
    <Sponsors />
  </Layout>
)

export default page
